import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b9e992b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alerts__container" }
const _hoisted_2 = { class: "dt-card alerts__list" }
const _hoisted_3 = { class: "dt-card__heading" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "dt-card__heading-title" }, "Alert Servers", -1))
const _hoisted_5 = { class: "dt-card__body" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "dt-list"
}
const _hoisted_8 = {
  key: 0,
  class: "dt-list__status"
}
const _hoisted_9 = { class: "dt-list__content" }
const _hoisted_10 = { class: "dt-list__title" }
const _hoisted_11 = { class: "dt-list__sub-title" }
const _hoisted_12 = { class: "time" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt-icon",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" })
], -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "alerts__no-search-results"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No alert servers match search", -1))
const _hoisted_19 = {
  key: 1,
  class: "empty-message"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "No CAP Servers", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: 2,
  class: "mt-5"
}
const _hoisted_23 = { class: "dt-card alerts__details" }
const _hoisted_24 = { class: "dt-card__heading" }
const _hoisted_25 = { class: "dt-card__heading-content" }
const _hoisted_26 = { class: "dt-card__heading-title" }
const _hoisted_27 = {
  key: 1,
  class: "dt-card__heading-title--none"
}
const _hoisted_28 = {
  ref: "serverDetailsBody",
  class: "dt-card__body"
}
const _hoisted_29 = { class: "row mb-1" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "alert-active" }, "ACTIVE", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "alert-inactive" }, "INACTIVE", -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "row" }
const _hoisted_37 = { class: "col-lg-6" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Provide a name for your Alert Server.", -1))
const _hoisted_39 = { class: "col-lg-6" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Choose whether Ditto should poll for alerts or if the alert server will push alerts to Ditto.", -1))
const _hoisted_41 = {
  key: 0,
  class: "row"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Enter this URL when configuring your CAP alert server to push emergency alerts to Ditto. The request type should be POST.", -1))
const _hoisted_43 = {
  key: 0,
  class: "callout callout--no-max callout--warning"
}
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "This URL is unique to your organization and should be kept secure. This URL could allow someone to send false emergency alerts to your organization's users.", -1))
const _hoisted_46 = [
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  class: "code"
}
const _hoisted_48 = {
  key: 2,
  class: "callout callout--no-max callout--warning"
}
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "icon icon--x-large icon--warning",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
], -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Ditto will generate a secure push URL for your CAP server once you finishing adding this Emergency Alert Server.", -1))
const _hoisted_51 = [
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = {
  key: 1,
  class: "row"
}
const _hoisted_53 = { class: "col-lg-6" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Provide the URL for your CAP alert server. Include http:// or https://.", -1))
const _hoisted_55 = { class: "col-lg-6" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Choose the type of request Ditto should make to this CAP server.", -1))
const _hoisted_57 = {
  key: 2,
  class: "row"
}
const _hoisted_58 = { class: "col-lg-6" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "If necessary provide a username for acessing your CAP alert server.", -1))
const _hoisted_60 = { class: "col-lg-6" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "If necessary provide a username for acessing your CAP alert server", -1))
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-lg-6" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Choose how long to display CAP alerts if an expiration time is not provided for the alert. Any alert cancelled by the CAP server will be immedately dismissed in Ditto regardless of this setting.", -1))
const _hoisted_65 = { class: "col-lg-6" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select the stauses of alerts to subscribe to from your CAP server.", -1))
const _hoisted_67 = { class: "row" }
const _hoisted_68 = { class: "col-lg-6" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select the severity level of alerts to subscribe to from your CAP server.", -1))
const _hoisted_70 = { class: "col-lg-6" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select the urgency of alerts to subscribe to from your CAP server.", -1))
const _hoisted_72 = { class: "row" }
const _hoisted_73 = { class: "col-lg-6" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select the certainty level of alerts to subscribe to from your CAP server.", -1))
const _hoisted_75 = { class: "col-lg-6" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select the types of alerts to subscribe to from your CAP server.", -1))
const _hoisted_77 = { class: "callout callout--informational callout--no-max mb-4" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("You can specify a combination of "),
    /*#__PURE__*/_createElementVNode("strong", null, "Rooms"),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("strong", null, "Locations"),
    /*#__PURE__*/_createTextVNode(" alerts processed from this server.")
  ]),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createTextVNode("If a "),
    /*#__PURE__*/_createElementVNode("strong", null, "Room"),
    /*#__PURE__*/_createTextVNode(" is part of a "),
    /*#__PURE__*/_createElementVNode("strong", null, "Location"),
    /*#__PURE__*/_createTextVNode(" it will be alerted only once. All "),
    /*#__PURE__*/_createElementVNode("strong", null, "Sublocations"),
    /*#__PURE__*/_createTextVNode(" of a "),
    /*#__PURE__*/_createElementVNode("strong", null, "Location"),
    /*#__PURE__*/_createTextVNode(" will receive the alerts from this server.")
  ])
], -1))
const _hoisted_79 = { class: "row" }
const _hoisted_80 = { class: "col-lg-6" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select the Rooms to broadcast alerts to when received from your CAP server.", -1))
const _hoisted_82 = { class: "col-lg-6" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select the Locations to broadcast alerts to when received from your CAP server.", -1))
const _hoisted_84 = { key: 3 }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Recent Alerts", -1))
const _hoisted_86 = { class: "row" }
const _hoisted_87 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Alerts recently processed by Ditto from this CAP alert server.", -1))
const _hoisted_88 = { key: 4 }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Test Alerts", -1))
const _hoisted_90 = { class: "row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Send a Ditto test alert or copy and paste valid Common Alert Protocol XML generated by a CAP server.", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "callout callout--no-max callout--danger mb-3" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon icon--x-large icon--danger",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, "This will send an actual emergency alert to any linked rooms or locations. Ensure you only have test receivers configured or inform users of the test.")
], -1))
const _hoisted_93 = {
  key: 1,
  class: "alerts__details-loading"
}
const _hoisted_94 = {
  key: 2,
  class: "alerts__select-alert"
}
const _hoisted_95 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select a CAP Server to view details or press \"New Server\" to create a new CAP Emergency Alert Server.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_ModelSelector = _resolveComponent("ModelSelector")!
  const _component_AlertDetailModal = _resolveComponent("AlertDetailModal")!
  const _component_TierLimit = _resolveComponent("TierLimit")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_router_link, { to: "/alertservers/new" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { type: "primary" }, {
              default: _withCtx(() => [
                _createTextVNode("New Server")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.allEmergencyAlertServers && _ctx.allEmergencyAlertServers.length && !_ctx.isAlertServersLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.serverFilter,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.serverFilter) = $event)),
                placeholder: "Filter alert servers",
                clearable: ""
              }, {
                prefix: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["modelValue"]),
              (_ctx.filteredEmergencyAlertServers && _ctx.filteredEmergencyAlertServers.length)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                    _createVNode(_TransitionGroup, { name: "list" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredEmergencyAlertServers, (server) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: server.id,
                            class: _normalizeClass(["dt-list__item", { active: _ctx.selectedEmergencyAlertServer && server.id == _ctx.selectedEmergencyAlertServer.id  }])
                          }, [
                            _createVNode(_component_router_link, {
                              class: "alerts__alert-link",
                              to: '/alertservers/' + server.id
                            }, {
                              default: _withCtx(() => [
                                (server.is_active)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_9, [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(server.serverName), 1),
                                  _createElementVNode("div", _hoisted_11, [
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(server.serverType) + " Server", 1)
                                  ])
                                ]),
                                _createVNode(_component_el_tooltip, {
                                  effect: "dark",
                                  content: "Deactivate",
                                  placement: "bottom",
                                  "hide-after": 0,
                                  "show-after": 500
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      (server.is_active)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "dt-list__item-delete",
                                            onClick: _withModifiers(($event: any) => (_ctx.deactivateAlertServer(server)), ["stop","prevent"])
                                          }, _hoisted_15, 8, _hoisted_13))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ], 2))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("img", {
                      src: require('../../assets/images/Whats-Mirroring.png')
                    }, null, 8, _hoisted_17),
                    _hoisted_18
                  ]))
            ], 64))
          : (!_ctx.isAlertServersLoading && _ctx.allEmergencyAlertServers.length == 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
            : (_ctx.isAlertServersLoading)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_22, null, 512)), [
                  [_directive_loading, _ctx.isAlertServersLoading]
                ])
              : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("section", _hoisted_23, [
      ((_ctx.selectedEmergencyAlertServer && _ctx.selectedEmergencyAlertServer.id && !_ctx.creationMode) || _ctx.selectedEmergencyAlertServer && _ctx.creationMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createVNode(_component_el_tooltip, {
                  effect: "dark",
                  content: _ctx.selectedEmergencyAlertServer.serverName,
                  placement: "bottom-start",
                  "show-after": 1000
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("h2", _hoisted_26, [
                      (_ctx.selectedEmergencyAlertServer.serverName)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.selectedEmergencyAlertServer.serverName), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock("em", _hoisted_27, "New Server"))
                    ])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, { to: "/alertservers" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { class: "ms-3" }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cancel")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.creationMode && _ctx.selectedEmergencyAlertServer.id && _ctx.selectedEmergencyAlertServer.is_active)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "alerts__deactivate-button",
                      plain: "",
                      type: "primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deactivateAlertServer(_ctx.selectedEmergencyAlertServer)))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Deactivate")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.selectedEmergencyAlertServer.is_active)
                  ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "ms-3",
                      type: "primary",
                      onClick: _ctx.onSubmit
                    }, {
                      default: _withCtx(() => [
                        (_ctx.creationMode)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode("Create Server")
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode("Save Server")
                            ], 64))
                      ]),
                      _: 1
                    }, 8, ["onClick"])), [
                      [_directive_loading, _ctx.alertCreationLoading]
                    ])
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_el_form, {
                "hide-required-asterisk": "",
                ref: "serverForm",
                rules: _ctx.rules,
                "label-position": "top",
                model: _ctx.selectedEmergencyAlertServer
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    (_ctx.selectedEmergencyAlertServer && _ctx.selectedEmergencyAlertServer.is_active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_30, _hoisted_32))
                      : _createCommentVNode("", true),
                    (_ctx.selectedEmergencyAlertServer && !_ctx.selectedEmergencyAlertServer.is_active)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _hoisted_35))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_el_form_item, {
                        prop: "serverName",
                        label: "Name"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_38,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.selectedEmergencyAlertServer.serverName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.serverName) = $event)),
                            placeholder: "My Emergency CAP Server"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_el_form_item, { label: "Type" }, {
                        default: _withCtx(() => [
                          _hoisted_40,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedEmergencyAlertServer.serverType,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.serverType) = $event)),
                            placeholder: "Type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Push" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Push")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Poll" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Poll")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  (_ctx.selectedEmergencyAlertServer.serverType == 'Push')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_form_item, { label: "Server URL" }, {
                            default: _withCtx(() => [
                              _hoisted_42,
                              (_ctx.selectedEmergencyAlertServer && _ctx.selectedEmergencyAlertServer.serverToken)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_46))
                                : _createCommentVNode("", true),
                              (_ctx.pushServerURL)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.pushServerURL), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_48, _hoisted_51))
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEmergencyAlertServer.serverType == 'Poll')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          _createVNode(_component_el_form_item, { label: "Server URL" }, {
                            default: _withCtx(() => [
                              _hoisted_54,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.selectedEmergencyAlertServer.serverURL,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.serverURL) = $event)),
                                placeholder: "https://myalertserver.com"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_55, [
                          _createVNode(_component_el_form_item, { label: "Request Type" }, {
                            default: _withCtx(() => [
                              _hoisted_56,
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selectedEmergencyAlertServer.serverRequest,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.serverRequest) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_option, {
                                    value: "post",
                                    label: "POST"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("POST")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "get",
                                    label: "GET"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("GET")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_option, {
                                    value: "put",
                                    label: "PUT"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("PUT")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEmergencyAlertServer.serverType == 'Poll')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _createElementVNode("div", _hoisted_58, [
                          _createVNode(_component_el_form_item, { label: "Username" }, {
                            default: _withCtx(() => [
                              _hoisted_59,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.selectedEmergencyAlertServer.serverUser,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.serverUser) = $event)),
                                placeholder: "Enter a username"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(_component_el_form_item, { label: "Password" }, {
                            default: _withCtx(() => [
                              _hoisted_61,
                              _createVNode(_component_el_input, {
                                modelValue: _ctx.selectedEmergencyAlertServer.serverPassword,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.serverPassword) = $event)),
                                placeholder: "Enter a password"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_62, [
                    _createElementVNode("div", _hoisted_63, [
                      _createVNode(_component_el_form_item, { label: "Default Expiration" }, {
                        default: _withCtx(() => [
                          _hoisted_64,
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.selectedEmergencyAlertServer.alertExpirationDefaultDuration,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.alertExpirationDefaultDuration) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, {
                                value: "1",
                                label: "1 minute"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("1 minute")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, {
                                value: "5",
                                label: "15 minutes"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("15 minutes")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, {
                                value: "15",
                                label: "30 minutes"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("30 minutes")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, {
                                value: "30",
                                label: "60 minutes"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("60 minutes")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, {
                                value: "60",
                                label: "Until Cancel alert is received"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Until Cancel alert is received")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, {
                                value: "9999999",
                                label: "1 minute"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("1 minute")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_65, [
                      _createVNode(_component_el_form_item, { label: "Alert Statuses" }, {
                        default: _withCtx(() => [
                          _hoisted_66,
                          _createVNode(_component_el_select, {
                            multiple: "",
                            modelValue: _ctx.selectedEmergencyAlertServer.statuses,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.statuses) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Actual" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Actual")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Exercise" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Exercise")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "System" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("System")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Test" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Test")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Draft" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Draft")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_67, [
                    _createElementVNode("div", _hoisted_68, [
                      _createVNode(_component_el_form_item, { label: "Alert Severities" }, {
                        default: _withCtx(() => [
                          _hoisted_69,
                          _createVNode(_component_el_select, {
                            multiple: "",
                            modelValue: _ctx.selectedEmergencyAlertServer.severities,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.severities) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Extreme" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Extreme")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Severe" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Severe")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Moderate" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Moderate")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Minor" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Minor")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Unknown" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Unknown")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_70, [
                      _createVNode(_component_el_form_item, { label: "Alert Urgencies" }, {
                        default: _withCtx(() => [
                          _hoisted_71,
                          _createVNode(_component_el_select, {
                            multiple: "",
                            modelValue: _ctx.selectedEmergencyAlertServer.urgencies,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.urgencies) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Immediate" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Immediate")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Expected" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Expected")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Future" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Future")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Past" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Past")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Draft" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Draft")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, [
                      _createVNode(_component_el_form_item, {
                        label: "Alert Certainties",
                        class: "mb-lg-0"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_74,
                          _createVNode(_component_el_select, {
                            multiple: "",
                            modelValue: _ctx.selectedEmergencyAlertServer.certainties,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.certainties) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Observed" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Observed")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Likely" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Likely")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Possible" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Possible")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Unlikely" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Unlikely")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Unknown" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Unknown")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _createVNode(_component_el_form_item, {
                        label: "Alert Types",
                        class: "mb-lg-0"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_76,
                          _createVNode(_component_el_select, {
                            multiple: "",
                            modelValue: _ctx.selectedEmergencyAlertServer.alertTypes,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.selectedEmergencyAlertServer.alertTypes) = $event))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_option, { value: "Geo" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Geo - Geophysical")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Met" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Met - Meteorological")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Safety" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Safety - General emergency and public safety")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Security" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Security - Law enforcement")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Rescue" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Rescue - Rescue and recovery")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Fire" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Fire - Fire suppression and rescue")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Health" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Health - Medical and public health")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Env" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Env - Pollution and other environmental")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Transport" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Transport - Public and private transportatio")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Infra" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Infra - Utility, tele, other non-transport infrastructure")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "CBRNE" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("CBRNE - Chem, Bio, Radio, Nuclear or High-Yield Explosive")
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_option, { value: "Other" }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Other")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_component_el_divider),
                  _createElementVNode("div", _hoisted_77, [
                    _createVNode(_component_Icon, { icon: _ctx.mdiLightbulb }, null, 8, ["icon"]),
                    _hoisted_78
                  ]),
                  _createElementVNode("div", _hoisted_79, [
                    _createElementVNode("div", _hoisted_80, [
                      _createVNode(_component_el_form_item, {
                        ref: "roomsForAlertServer",
                        class: "mb-lg-0",
                        label: "Rooms",
                        prop: "rooms"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_81,
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.manageRoomsClickHandler
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.selectedServerRoomsCount) + " Rooms", 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }, 512)
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _createVNode(_component_el_form_item, {
                        ref: "locationsForAlertServer",
                        class: "mb-0",
                        label: "Locations",
                        prop: "locations"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_83,
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _ctx.manageLocationsClickHandler
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.selectedServerLocationsCount) + " Locations", 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }, 512)
                    ])
                  ]),
                  (_ctx.selectedEmergencyAlertServer.id && !_ctx.creationMode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                        _createVNode(_component_el_divider),
                        _hoisted_85,
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", null, [
                            _hoisted_87,
                            _createVNode(_component_el_table, {
                              data: _ctx.recentAlerts,
                              "empty-text": "No recent alerts for this Emergency Alert Server",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_table_column, {
                                  label: "Details",
                                  align: "center"
                                }, {
                                  default: _withCtx((scope) => [
                                    _createVNode(_component_Icon, {
                                      onClick: _withModifiers(($event: any) => (_ctx.showAlertDetails(scope.row)), ["stop","prevent"]),
                                      icon: _ctx.mdiInformation
                                    }, null, 8, ["onClick", "icon"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "identifier",
                                  label: "Identifier"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "msgType",
                                  label: "Type"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "category",
                                  label: "Category"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "severity",
                                  label: "Severity"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "ipAddress",
                                  label: "IP Address"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "sender",
                                  label: "Sender"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "createdAt",
                                  label: "Sent Time (UTC)"
                                }),
                                _createVNode(_component_el_table_column, {
                                  prop: "status",
                                  label: "Status"
                                })
                              ]),
                              _: 1
                            }, 8, ["data"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEmergencyAlertServer.id && !_ctx.creationMode && _ctx.selectedEmergencyAlertServer.serverType == 'Push')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _createVNode(_component_el_divider),
                        _hoisted_89,
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", null, [
                            _hoisted_91,
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.textXml,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.textXml) = $event)),
                              rows: 15,
                              type: "textarea",
                              class: "mb-3"
                            }, null, 8, ["modelValue"]),
                            _hoisted_92,
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendTestAlert
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Send Alert")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["rules", "model"])
            ], 512)
          ], 64))
        : (_ctx.isAlertServerDetailsLoading)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_93, null, 512)), [
              [_directive_loading, _ctx.isAlertServerDetailsLoading]
            ])
          : (_openBlock(), _createElementBlock("div", _hoisted_94, [
              (_ctx.$route.params.id && !_ctx.selectedEmergencyAlertServer)
                ? (_openBlock(), _createElementBlock("p", _hoisted_95, "Alert Server not found."))
                : _createCommentVNode("", true),
              _hoisted_96
            ]))
    ]),
    (_ctx.selectedEmergencyAlertServer)
      ? (_openBlock(), _createBlock(_component_ModelSelector, {
          key: 0,
          "includes-all": true,
          title: "Add Rooms to Alert Server",
          subTitle: _ctx.selectedEmergencyAlertServer.serverName ? _ctx.selectedEmergencyAlertServer.serverName : 'New Alert Server',
          modelTypeName: "rooms",
          onSelectionPoolChange: _ctx.roomSelectionChanged,
          ref: "roomModelSelector",
          hideSaveButton: _ctx.hideSaveButton
        }, null, 8, ["subTitle", "onSelectionPoolChange", "hideSaveButton"]))
      : _createCommentVNode("", true),
    (_ctx.selectedEmergencyAlertServer)
      ? (_openBlock(), _createBlock(_component_ModelSelector, {
          key: 1,
          "includes-all": true,
          title: "Add Locations to Alert Server",
          subTitle: _ctx.selectedEmergencyAlertServer.serverName ? _ctx.selectedEmergencyAlertServer.serverName : 'New Alert Server',
          modelTypeName: "locations",
          onSelectionPoolChange: _ctx.locationSelectionChanged,
          ref: "locationModelSelector",
          hideSaveButton: _ctx.hideSaveButton
        }, null, 8, ["subTitle", "onSelectionPoolChange", "hideSaveButton"]))
      : _createCommentVNode("", true),
    _createVNode(_component_AlertDetailModal, {
      modelValue: _ctx.isAlertDetailsVisible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.isAlertDetailsVisible) = $event)),
      alertInfo: "selectedRecentAlertDetails",
      ref: "alertDetailsModal"
    }, null, 8, ["modelValue"]),
    _createVNode(_component_TierLimit, {
      modelValue: _ctx.showTierCallout,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.showTierCallout) = $event)),
      isCallout: false,
      isLimit: false,
      message: "Upgrade your Ditto account to unlock alerts."
    }, null, 8, ["modelValue"])
  ]))
}